// Todo endereço do ERP montado pelo Whaticket sai daqui.
//
// A base é a raiz do ERP do usuário (ex.: "https://grupomr.icodeti.com.br/grupomr"),
// gravada no localStorage pelo deep link do CRM (ver hooks/useAuth.js) e reidratada do
// `user.urlRetornoCrm` que o backend devolve no login e no refresh. Quem a informa é
// sempre o ERP, com o host da requisição do próprio usuário — por isso cliente que acessa
// por domínio próprio volta pelo domínio dele.
//
// Sem base, as funções devolvem `null` e quem chama avisa. Elas NÃO podem devolver um
// caminho solto: concatenar a base ausente produzia "null/app/crm/lead/form.xhtml?lead=1",
// URL relativa que o navegador resolve no próprio Whaticket ("/tickets/null/app/...") e
// que não casa com rota nenhuma — a tela em branco do #14631. É a mesma régua do backend
// (helpers/UrlRetornoCrm), e vale na leitura também: base sem http(s) é meia base, e meia
// base dá exatamente o mesmo caminho relativo.

const normalizar = valor => {
	const url = (valor || "").replace(/\/+$/, "");
	return /^https?:\/\/.+/i.test(url) ? url : "";
};

const base = () => normalizar(localStorage.getItem("url_retorno_crm"));

export const temUrlErp = () => !!base();

// O "/index.xhtml" é obrigatório: só a raiz cai na tela de login do ERP.
export const urlRetornoErp = () => {
	const raiz = base();
	return raiz ? `${raiz}/index.xhtml` : null;
};

export const urlLeadNoCrm = leadId => {
	const raiz = base();
	return raiz && leadId ? `${raiz}/app/crm/lead/form.xhtml?lead=${leadId}` : null;
};

// Grava a base que veio no deep link do CRM — lá o "_" é "/". Retorno que não dá para
// navegar não grava, e a base anterior continua valendo.
export const guardarBaseErpDoDeepLink = retorno => {
	const url = normalizar((retorno || "").replace(/_/g, "/"));
	if (url) localStorage.setItem("url_retorno_crm", url);
};

// Reidrata a base a partir do usuário devolvido pelo backend — é o que dá atalho a quem
// abre o Whaticket pelo favorito, sem nunca passar pelo login por deep link.
//
// `substituir` é a diferença entre os dois chamadores: no login o valor é do usuário que
// está entrando agora e deve vencer o que sobrou de quem usou a máquina antes (o deep link
// desta entrada sobrescreve logo depois, se vier); no boot a sessão já é dele e o
// localStorage é mais específico — pode ter o domínio desta navegação, e o banco, o de
// outra máquina.
export const guardarBaseErpDoUsuario = (usuario, { substituir = false } = {}) => {
	const url = normalizar(usuario?.urlRetornoCrm);
	if (!url) return;
	if (!substituir && base()) return;
	localStorage.setItem("url_retorno_crm", url);
};

export default urlRetornoErp;
